import Common from '../common.vue'
import { registerModule } from '@/app/app.store'


export default {
  path: '/category',
  component: Common,
  children: [
    {
      name: 'category',
      path: '',
      component: () => import('./category.vue'),
      beforeEnter: (to: any, from: any, next: () => void) => {
        import('./category.service').then(({ STORE }) => {
          if (STORE) registerModule(to, STORE)
          next()
        })
      }
    },
    {
      name: 'consultantList',
      path: 'consultantList',
      component: () => import('./consultantList/consultantList.vue')
    }
  ]
}
